import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import configSiteUrls from '../../configs/configSiteUrls';

type NavLinkProps = {
  link?: string | null;
  noticiaId?: string | null;
  label: string;
  layout: 'site' | 'escolaLegislativo';
};

/** Detecta link externo */
const isExternal = (url?: string | null) => !!url && (/^https?:\/\//.test(url) || url.includes('www'));

export function NavLinkButton({ link, noticiaId, label, layout }: NavLinkProps) {
  const buttonStyle = {
    fontSize: '12px',
    fontWeight: 700,
    color: layout === 'escolaLegislativo' ? 'primary.main' : 'inherit',
    borderBottom: '2px solid transparent',
    borderRadius: 0,
    '&:hover': {
      borderBottom: '2px solid #1976d2',
      backgroundColor: 'transparent'
    }
  };

  // Link interno de notícia sempre tem prioridade
  if (noticiaId) {
    const to = `${configSiteUrls.SITE_NOTICIA_PUBLIC_VIEW_LK}${noticiaId}`;
    return (
      <Button component={Link} to={to} sx={buttonStyle}>
        {label}
      </Button>
    );
  }

  // Link externo
  if (link && isExternal(link)) {
    return (
      <Button component="a" href={link} target="_blank" rel="noopener noreferrer" sx={buttonStyle}>
        {label}
      </Button>
    );
  }

  // Link interno normal
  if (link) {
    return (
      <Button component={Link} to={link} sx={buttonStyle}>
        {label}
      </Button>
    );
  }

  // Fallback caso não haja link
  return <Button sx={buttonStyle}>{label}</Button>;
}
